let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3WUT3")).then(() => parcelRequire('24yoB'));